export default __webpack_public_path__ + "static/media/gallery_05.b9c1e591.jpg";